import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Logo from './Logo';
import LogoSmall from './LogoSmall';

const MenuToggle = ({ isOpen, onClick }) => (isOpen ? (
  <Logo onClick={ onClick } />
) : (
  <LogoSmall onClick={ onClick } />
));

export default MenuToggle;
